$(document).ready(function() {
  let automaticallyDisplayedUnclosableModals = ['terms-modal'];

  automaticallyDisplayedUnclosableModals.forEach(function (modalId) {
    showUnclosableModel(modalId);
  })

  let automaticallyDisplayedClosableModals = ['onboardingModal', 'userWelcomeModal', 'companyWelcomeModal'];

  automaticallyDisplayedClosableModals.forEach(function (modalId) {
    showClosableModel(modalId);
  })
});

function showUnclosableModel(modalId) {
  if (document.getElementById(modalId)) {
    new bootstrap.Modal(document.getElementById(modalId), {
      keyboard: false,
      backdrop: "static"
    }).show();
  }
}

function showClosableModel(modalId) {
  if (document.getElementById(modalId)) {
    new bootstrap.Modal(document.getElementById(modalId)).show();
  }
}
